


































import { defineComponent } from "@vue/composition-api";
import { ContentSet } from "@scrile/api-provider/dist/api/ContentSetProvider";
import { getElement } from "@/lib/elementHelpers";
import BaseButton from "@/components/BaseButton";
import BaseIcon from "@/components/BaseIcon";
import CustomScroll from "@/components/CustomScroll";
import OptionPrice from "./components/OptionPrice";
import OptionSchedulePost from "./components/OptionSchedulePost";

export default defineComponent({
  name: "EditPostOptions",
  components: { OptionPrice, OptionSchedulePost, BaseButton, BaseIcon, CustomScroll },
  props: {
    postData: { type: Object as () => ContentSet, required: true },
  },
  data() {
    return {
      hasChevrons: true,
      emptyOptions: false,
      showOptions: false,
      saving: false,
    };
  },
  computed: {
    openOptions(): boolean {
      return !this.emptyOptions && this.showOptions;
    },
    showIcon(): string {
      return this.showOptions ? "sci-arrow-down" : "sci-gear";
    },
  },
  methods: {
    onShowClick() {
      this.showOptions = !this.showOptions;
    },
    onPublish() {
      this.saving = true;
      this.$emit("publish", () => {
        this.saving = false;
      });
    },
  },
  mounted() {
    const onUpdated = () => {
      this.hasChevrons = getElement(this.$refs["chevrons"]).childElementCount !== 0;
      this.emptyOptions = !this.hasChevrons && getElement(this.$refs["menu"]).childElementCount === 1;
    };
    const observer = new MutationObserver(onUpdated);
    observer.observe(getElement(this.$refs["menu"]), { childList: true });
    observer.observe(getElement(this.$refs["chevrons"]), { childList: true });
    onUpdated();
    this.$once("hook:beforeDestroy", () => {
      observer.disconnect();
    });
  },
});
